// extracted by mini-css-extract-plugin
export default {"loading":"_2gu91","details":"tTqYQ","product":"_13JYm","feedBenefitContainer":"_3uiPV"};